import { useEffect, useState } from 'react';
import { asset } from '../assets';

const MINIMUM_VISIBLE_MS = 1100;
const EXIT_DURATION_MS = 500;
const MAXIMUM_WAIT_MS = 4000;

export function Preloader() {
  const [exiting, setExiting] = useState(false);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const startedAt = performance.now();
    let exitTimer;
    let removalTimer;
    let maximumWaitTimer;
    let finishing = false;

    document.body.classList.add('preloader-active');

    const finish = () => {
      if (finishing) return;
      finishing = true;

      const remaining = Math.max(0, MINIMUM_VISIBLE_MS - (performance.now() - startedAt));
      exitTimer = window.setTimeout(() => {
        setExiting(true);
        removalTimer = window.setTimeout(() => {
          setVisible(false);
          document.body.classList.remove('preloader-active');
        }, EXIT_DURATION_MS);
      }, remaining);
    };

    if (document.readyState === 'complete') {
      finish();
    } else {
      window.addEventListener('load', finish, { once: true });
      maximumWaitTimer = window.setTimeout(finish, MAXIMUM_WAIT_MS);
    }

    return () => {
      window.removeEventListener('load', finish);
      window.clearTimeout(exitTimer);
      window.clearTimeout(removalTimer);
      window.clearTimeout(maximumWaitTimer);
      document.body.classList.remove('preloader-active');
    };
  }, []);

  if (!visible) return null;

  return (
    <div
      aria-label="Loading INGAZ Print"
      aria-live="polite"
      className={`site-preloader${exiting ? ' site-preloader-exiting' : ''}`}
      role="status"
    >
      <div className="preloader-glow preloader-glow-yellow" />
      <div className="preloader-glow preloader-glow-teal" />

      <div className="preloader-content">
        <div className="preloader-mark">
          <div className="preloader-paper-stack" aria-hidden="true">
            <span />
            <span />
            <span />
          </div>
          <img src={asset('assets/logoyellow.png')} alt="INGAZ Print" />
        </div>

        <div className="preloader-printer" aria-hidden="true">
          <span className="preloader-paper-input">
            <i />
            <i />
          </span>
          <span className="preloader-printer-body">
            <i className="preloader-printer-light" />
            <i className="preloader-printer-slot" />
          </span>
          <span className="preloader-paper-output">
            <i className="preloader-print-logo">I</i>
            <i />
            <i />
            <i />
          </span>
        </div>

        <div className="preloader-copy">
          <strong>IDEA TO IMPACT</strong>
          <span>Printing your experience</span>
        </div>

        <div className="preloader-progress" aria-hidden="true">
          <span />
        </div>
      </div>
    </div>
  );
}
